import { COUNTRY_TO_ISO_MAPPING, ISO_COUNTRY_CODES } from "@finway-group/shared/lib/consts/countries"

const datevCountryNameByCode = new Map<string, string>()
for (const [countryName, countryCode] of Object.entries(COUNTRY_TO_ISO_MAPPING)) {
    if (!datevCountryNameByCode.has(countryCode)) {
        datevCountryNameByCode.set(countryCode, countryName)
    }
}

const isGermanLanguage = (language: string) => language.toLowerCase().startsWith("de")

const getCountryDisplayName = ({ countryCode, language }: { countryCode: string; language: string }) => {
    if (isGermanLanguage(language)) {
        return datevCountryNameByCode.get(countryCode)
    }

    const displayName = new Intl.DisplayNames([language], { type: "region" }).of(countryCode)
    if (!displayName || displayName === countryCode) {
        return undefined
    }

    return displayName
}

export const getIsoCountryLabel = ({ countryCode, language }: { countryCode: string; language: string }) => {
    const displayName = getCountryDisplayName({ countryCode, language })
    if (!displayName) {
        return countryCode
    }

    return `${displayName} (${countryCode})`
}

export const buildIsoCountrySelectOptions = (language: string): Array<{ code: string; label: string }> =>
    [...ISO_COUNTRY_CODES]
        .map((code) => ({
            code,
            label: getIsoCountryLabel({ countryCode: code, language }),
        }))
        .sort((left, right) => left.label.localeCompare(right.label, language))
